var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.error)?_c('div',{staticClass:"gate-banner",class:_vm.kind,on:{"click":_vm.act}},[_c('span',[_vm._v(_vm._s(_vm.message))]),(_vm.kind !== 'error')?_c('b',[_vm._v(_vm._s(_vm.actionText)+" →")]):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }